module.exports = __webpack_public_path__ + "static/fhaLoanbg-672cec4c42105115052969cc08c8bb6d.jpg";